import { render } from "./SIdentify.vue?vue&type=template&id=12de1041&scoped=true"
import script from "./SIdentify.vue?vue&type=script&lang=js"
export * from "./SIdentify.vue?vue&type=script&lang=js"

import "./SIdentify.vue?vue&type=style&index=0&id=12de1041&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12de1041"]])

export default __exports__